import { IEvent } from "core-integration/src/store/events/types";
import {
  formatRawAsISO,
  formatRawAsLocal,
} from "core-integration/src/utils/datetime";
import { Cell, Column, Row, Table } from "plos/src/components/Table";
import { fixedTable } from "plos/src/styles/utils.css";
import { TableBody, TableHeader } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { EventDeadlineCountdown } from "../EventDeadlineCountdown";
import {
  countdownSection,
  deadlineCell,
  deadlineCol,
  eventNameCell,
  eventNameCol,
  upcomingContainer,
} from "./upcomingDeadlines.css";

interface UpcomingDeadlinesProps {
  events: IEvent[];
  onComplete?: () => void;
}

const UpcomingDeadlines = ({ events, onComplete }: UpcomingDeadlinesProps) => {
  const { t } = useTranslation("status");

  if (events.length === 0) {
    return null;
  }

  const [nextEvent, ...remainingEvents] = events;

  const upcomingHeading =
    remainingEvents.length === 1
      ? t("upcomingDeadline", "Upcoming Deadline")
      : t("upcomingDeadlines", "Upcoming Deadlines");

  const dateFormat = "E d MMM, HH:mm";

  return (
    <div className={upcomingContainer}>
      <h3>{t("nextDeadline", "Next Deadline")}</h3>
      <div className={countdownSection}>
        <EventDeadlineCountdown event={nextEvent} onComplete={onComplete} />
      </div>
      {remainingEvents.length > 0 && (
        <>
          <h3 aria-hidden="true">{upcomingHeading}</h3>
          <Table
            className={fixedTable}
            aria-label={t("upcomingDeadlines", "Upcoming Deadlines") as string}
          >
            <TableHeader>
              <Column isRowHeader className={eventNameCol}>
                {t("gameweek", "Gameweek")}
              </Column>
              <Column className={deadlineCol}>
                {t("deadline", "Deadline")}
              </Column>
            </TableHeader>
            <TableBody>
              {remainingEvents.map((event) => (
                <Row key={event.id}>
                  <Cell className={eventNameCell}>{event.name}</Cell>
                  <Cell className={deadlineCell}>
                    <time dateTime={formatRawAsISO(event.deadline_time)}>
                      {formatRawAsLocal(event.deadline_time, dateFormat)}
                    </time>
                  </Cell>
                </Row>
              ))}
            </TableBody>
          </Table>
        </>
      )}
    </div>
  );
};

export default UpcomingDeadlines;
